import { Tooltip } from '@vtex/admin-ui'
import { FormattedMessage, useIntl } from 'react-intl'
import { Tag } from 'ui'

import type { Cluster as ClusterType } from 'typings'
import { messages } from './messages'

type ClusterProps = {
  cluster: ClusterType | undefined
}

export function Cluster(props: ClusterProps) {
  const { cluster } = props
  const { formatList } = useIntl()

  if (!cluster?.expressions.length) return null

  const processTooltip = () =>
    formatList(cluster.expressions ?? [], {
      type: cluster.operator === 'all' ? 'conjunction' : 'disjunction',
    })

  return (
    <Tooltip text={processTooltip()}>
      <Tag>
        <FormattedMessage {...messages.cluster.title} />
      </Tag>
    </Tooltip>
  )
}
